import { faBook, faList, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Logo } from "../Logo";
import { MainLayout } from "./MainLayout";
import { OrgLayout } from "./OrgLayout";

export const Organization = (props:any) => {
    const { url } = useRouteMatch();

    const navigation = [
        { name: 'Profile', to: `${url}/profile`, icon: faUser },
        { name: 'Users', to: `${url}/users`, icon: faUsers },
        //{ name: 'Account', to: `${url}/account`, icon: faBook },
        { name: 'Usage', to: `${url}/usage`, icon: faList },
    ];
    
    return (
        <MainLayout {...props} navigation={navigation} logo={<Logo {...props} />}>
            <OrgLayout {...props}/>
        </MainLayout>
    );
}